import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// #276: real links, so Tab reaches them; an <a> without href is skipped.
function Footertwo() {
  return (
    <><footer className='landing'>

      <div className="container-fluid">

        <Row className='desktop-footer'>
          <Col>

            <p>Copyright © 2025 XCUTTA. All Rights Reserved.</p>
          </Col>
          <Col className='d-flex justify-content-end'>

            <p><Link to="/PrivacyPolicy">Privacy Policy</Link></p>
          </Col>

        </Row>
        <Row className='mob-footer'>
          <Col md="12">

            <p>Copyright © 2025 XCUTTA. All Rights Reserved.</p>
          </Col>
          <Col md="12">

            <p><Link to="/PrivacyPolicy">Privacy Policy</Link></p>
          </Col>

        </Row>
      </div>
    </footer></>
  );
}

export default Footertwo;